import ReactSignatureCanvas from "react-signature-canvas";
import { FormItem, FormLabel, FormMessage } from "./ui/form";

import SignatureCanvas from 'react-signature-canvas'
import { useRef } from "react";

const WaiverSignatureCanvas: React.FC<{
    title?: string,
    value?: string | null,
    onChange: (signature: string) => void,
}> = (props) => {
    const signCanvas = useRef<SignatureCanvas>(null)

    const onSignatureStrokeEnded = () => {
        if (signCanvas.current) {
            const signatureData = signCanvas.current.getTrimmedCanvas().toDataURL('image/png')
            props.onChange(signatureData)
        }
    }

    const clearSignatureCanvas = () => {
        if (signCanvas.current) {
            signCanvas.current.clear()
            props.onChange('')
        }
    }

    return <FormItem>
        <FormLabel className="text-base font-semibold text-[#ffffff] flex flex-row justify-between">
            <span>{props.title || 'Electronic Signature'}</span>
            {props.value && <a href="#" onClick={clearSignatureCanvas} className="text-primary">Clear</a>}
        </FormLabel>
        <div className="rounded-md border border-[#4C4C4C] overflow-hidden">
            <ReactSignatureCanvas onEnd={onSignatureStrokeEnded} ref={signCanvas} backgroundColor="rgba(255,255,255,255)" canvasProps={{
                className: 'w-full',
                height: 400
            }} />
        </div>
        <FormMessage />
    </FormItem>
}

export default WaiverSignatureCanvas;